/**
 * Data hook for the Operations Closed surface.
 *
 *   useClosed() — polls GET /api/closed every 60s. Read-only; cases enter the
 *   closed book upstream (the portal and the staff doors) when a matter reaches Case
 *   Closed.
 *
 * Polls at 60s — slower than the Placed book's 30s and far slower than the
 * routing worklists' 15s. The graveyard is the most static surface in the
 * system: a closed matter never changes, and new arrivals trickle in over
 * days. There is nothing to gain from a tight refresh.
 *
 * Spec: engineering/command-center/docs/port-notes/closed.md (evicted 2026-08-29, #775 round 10)
 */

import { ClosedResponseSchema } from "@command-center/shared";
import { createPollingQuery } from "./create-polling-query";

export const useClosed = createPollingQuery({
  queryKey: ["closed"] as const,
  path: "/api/closed",
  schema: ClosedResponseSchema,
  refetchIntervalMs: 60_000,
});
